import React from "react";
import { useSelector } from "react-redux";
import { getContactUsURL } from "../../util/common";
import { ApplicationState } from "../../store";
import { useTranslation } from "react-i18next";

const NeedHelp = (props: any) => {
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.isIdfPartner
            : false
    );
    const contactUsURL = getContactUsURL(partnerID, isIDFPartner);
    const isPartnerIdIsNexshield = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 540
                ? true
                : false
            : false
    );
    const allowLoginWithUserName: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.allowLoginWithUserName
            ? state.configurationState.configuration.partnerConfig.allowLoginWithUserName
            : false
    );
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const { t: tLang, i18n: i18nLang } = useTranslation();

    return (
        <React.Fragment>
            <h2 className="content-sub-title">{tLang("forgotPassword.needHelp")}</h2>
            {isPartnerIdIsNexshield ? (
                <p>
                    {tLang("forgotPassword.contactUsOn")} <a href="tel:+1 833-306-0528">+1 833-306-0528</a>{" "}
                    {allowLoginWithUserName ? tLang("forgotPassword.helpTextEmailOrUser") : tLang("forgotPassword.helpTextEmail")}
                </p>
            ) : (
                <p>
                    <span>
                        {tLang("forgotPassword.callUs")} {partnerPhoneNumber}
                    </span>
                </p>
            )}
        </React.Fragment>
    );
};

export default NeedHelp;
